import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BatchService } from 'src/services/batch.services';
import { GlobalCfgService } from 'src/services/globalcfg.service';
import { MessageService } from 'src/services/message.service';

@Component({
  selector: 'rm-create-existing-batch-label',
  templateUrl: './create-existing-batch-label.component.html',
  styleUrls: ['./create-existing-batch-label.component.css']
})
export class CreateExistingBatchLabelComponent implements OnInit {
  form: FormGroup;
  subscriptions: any[] = [];
  batches: any;
  gcp: string;
  selectedBatchNo: any;
  labelCount: number = 1;

  packageLevels: any[] = [
    {displayName: "Inner Secondary", name: "inner-secondary"},
    {displayName: "Secondary", name: "secondary"},
    {displayName: "Outer Secondary", name: "outer-secondary"}
  ];

  constructor(
    private dialogRef: MatDialogRef<CreateExistingBatchLabelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private batchService: BatchService,
    private msgService: MessageService,
    private globalCfgService: GlobalCfgService,
  ) { }

  ngOnInit() {
    if (!this.gcp) {
      this.gcp = this.globalCfgService.getGcp();
    }

    this.form = new FormGroup({
      batchNo: new FormControl(),
      packageLevel: new FormControl(),
      quantity: new FormControl(),
      labelCnt: new FormControl()
    });
    
    // this.loadBatches();
  }

  // loadBatches() {
  //   this.batchService.get(this.gcp).subscribe((response: any) => {
  //     this.batches = response;
  //     if (this.batches.length > 0) {
  //       this.selectedBatchNo = this.batches[0].batchNo;
  //     }
  //   });
  // }

  cancel() {
      this.dialogRef.close();
  }

  onSubmit() { }
  
  generateLabel(values) {
    var rec = {
      batchNo: values.batchNo,
      packageLevel: values.packageLevel,
      quantity: values.quantity,
      labelCnt: values.labelCnt
    };

    this.batchService.genExistingNonAggBatchLabels(rec).subscribe(
      (response: any)=> {
        if (response.status) {
          this.dialogRef.close();
          this.msgService.showSuccess(this.msgService.labelsEmail);
        } else {
          this.msgService.showError(this.msgService.labelsCreateFail);
        }
      }
    );
  }
}
